import { CheckCircleIcon } from '@/components/ui/icons'
import { useTranslation } from '@/translations/i18n'

export const SuccessView = ({ isUpgrade }: { isUpgrade?: boolean }) => {
	const { t } = useTranslation()

	return (
		<div className='col-span-full flex h-full w-full flex-col items-center justify-center gap-8 text-center text-neutral-900'>
			<CheckCircleIcon className='text-success-600' size={40} />
			<div className='flex flex-col items-center gap-2'>
				<h1 className='font-medium text-2xl'>
					{isUpgrade
						? t('experience_shell:submitted_shell2_title')
						: t('experience_shell:submitted_to_host')}
				</h1>
				<p className='text-xl'>
					{isUpgrade
						? t('experience_shell:submitted_shell2_description')
						: t('experience_shell:submitted_to_host_description')}
				</p>
			</div>
		</div>
	)
}
